export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_july4-2d9b0a6e8dfcdfdbed318e8d0f316c19.jpg";